import { render, staticRenderFns } from "./VaultFolder.vue?vue&type=template&id=6a69f1fa"
import script from "./VaultFolder.vue?vue&type=script&lang=js"
export * from "./VaultFolder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports